export type MazingProps = {
  mazingUrl: string;
};

export const MazingRenderer = ({ mazingUrl }: MazingProps) => (
  <iframe
    data-testid="MazingRenderer"
    title="mazing"
    style={{
      border: '0',
      height: '100%',
      width: '100%',
    }}
    src={mazingUrl}
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;"
  />
);
